(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/helper-accessibility/assets/javascripts/handlebars-helpers.js') >= 0) return;  svs.modules.push('/components/lb-utils/helper-accessibility/assets/javascripts/handlebars-helpers.js');

'use strict';

function registerHelpers(hbs) {
  hbs.registerHelper('getAriaObj', function () {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const ariaObj = {};
    Object.keys(options.hash).forEach(key => {
      if (options.hash[key]) {
        ariaObj[key] = options.hash[key];
      }
    });
    return ariaObj;
  });

  hbs.registerHelper('concat', () => Array.from(arguments).slice(0, -1).join(''));
}
if (svs.isServer) {
  const hbs = require('hbs');
  registerHelpers(hbs);
} else {
  registerHelpers(Handlebars);
}

 })(window);